import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const pageLimit = 10;

export default function usePaginatedVideos(pageNumber) {
  const reduxState = useSelector((state) => state);
  const [paginatedVideos, setPaginatedVideos] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    setPaginatedVideos([]);
  },[reduxState.allContent.filteredVideos])

  useEffect(() => {
    setLoading(true);
    setError(false);

    //set paginated results from filtered content
    const startIndex = (pageNumber - 1) * pageLimit,
      endIndex = pageNumber * pageLimit;
    setPaginatedVideos((prevVideos) => [
      ...prevVideos,
      ...reduxState.allContent.filteredVideos.slice(startIndex, endIndex),
    ]);
    setHasMore(reduxState.allContent.filteredVideos.length > 0);
    setLoading(false);
  }, [pageNumber,reduxState.allContent.filteredVideos]);

  return { loading, error, paginatedVideos, hasMore };
}
